import { StopType } from 'harmony-constants';
import { L } from 'harmony-language';
import { Load } from '../../../../../types';
import { areStopTypeWeightsEqual } from '../../../drafts/utils/validate-drafts';

const areStopQuantitiesValid = (editedLoad: Load) => {
    const val = editedLoad.stops.reduce((acc, cur) => {
        const quantity = cur.quantity || 0;
        const value = cur.type === StopType.Origin ? quantity : -1 * quantity;
        return acc + value;
    }, 0);

    return val === 0;
}

const atLeastOneHasValue = (editedLoad: Load) => {
    return editedLoad.stops.some((s) => s.quantity || s.weight);
}

// because either quantity or weight may or may not be on the page
// need to run both quantity and weight validations on each type of input
export const getQuantityWeightValidations = (
    editedLoad: Load,
    convertFromGrams: (g: number) => number,
    weightPrecision: number,
) => {
    return [
        // quantity validations
        {
            isValid: () => areStopQuantitiesValid(editedLoad),
            message: L.loadInvalidQuantity(),
        },
        // weight validations
        {
            isValid: () => areStopTypeWeightsEqual(editedLoad.stops, convertFromGrams, weightPrecision),
            message: L.loadInvalidWeight(),
        },
        // both
        {
            isValid: () => atLeastOneHasValue(editedLoad),
            message: L.loadInvalidStopValue(),
        },
    ];
}
